(function () {

    var elems = document.querySelectorAll('[btn-copy]'),
        index,
        max;


    if ( elems ) {
        for (index = 0, max = elems.length; index < max; index++) {

            elems[index].addEventListener('click', function (e) {

                e.preventDefault();

                var el = $(this);

                console.log(elems);

                $('[btn-copy]').removeClass('icon-check');
                $(el).addClass('icon-check');

                var $temp = $('<input id="temp-copy">');

                $("body").append($temp);

                $temp.val($(el).attr('href')).select();

                copy('temp-copy');

                $temp.remove();
            });
        }
    }

    var copy = function (elementId) {

        var input = document.getElementById(elementId);
        var isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);

        if (isiOSDevice) {

            var editable = input.contentEditable;
            var readOnly = input.readOnly;

            input.contentEditable = true;
            input.readOnly = false;

            var range = document.createRange();
            range.selectNodeContents(input);

            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            input.setSelectionRange(0, 999999);
            input.contentEditable = editable;
            input.readOnly = readOnly;

        } else {
            input.select();
        }
        document.execCommand('copy');
    }
}());


